







import { Component, Vue } from "vue-property-decorator";
import GlobalFooterForSimple from "@/containers/GlobalFooterForSimple.vue";

@Component({
  components: { GlobalFooterForSimple }
})
export default class SimplesLayout extends Vue {}
